import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoadingEcmsComp: false,
    employeeEcmsAdjustmentData: [],
    success: false,
    error: false,
}

export const EcmsPayrunReducer = function (state = componentInitialState, action) {
    switch (action.type) {
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET:
            return {
                ...state,
                isLoadingEcmsComp: true,
                success: false,
                error: false,
                employeeEcmsAdjustmentData: []
            };
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE:
            return {
                ...state,
                isLoadingEcmsComp: true,
                success: false,
                error: false,
            };

        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET_SUCCESS:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD_SUCCESS:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_SUCCESS:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingEcmsComp: false,
                success: true,
                error: false,
                successMessage: action.payload?.message,
                employeeEcmsAdjustmentData: action.payload?.data?.data
            };

        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET_ERROR:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD_ERROR:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_ERROR:
        case ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE_ERROR:
            return {
                ...state,
                isLoadingEcmsComp: false,
                success: false,
                error: true,
                errorMessage: action.payload?.data?.error?.[0]?.message || "Something went wrong",
            };

        default:
            return state;
        }
}
